export default "__VITE_ASSET__BDcMp5DM__"